// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__TCWRi","log":"ModalInventoryLogs_log__WOzjd","date":"ModalInventoryLogs_date__3EBfS","userName":"ModalInventoryLogs_userName__2M5FW"};